const locationFieldConfig = {
  zipCode: {
    label: "Zipcode",
    maxLength: 20,
    pattern: /^(?!-)[0-9-]+$/,
    patternMessage:
      "Zipcode can include only numbers and hyphens, and cannot start with a hyphen.",
  },
  city: {
    label: "City",
    maxLength: 50,
    pattern: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
    patternMessage: "City can include only alphabets.",
  },
  state: {
    label: "State",
    maxLength: 50,
    pattern: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
    patternMessage: "State can include only alphabets.",
  },
  country: {
    label: "Country",
    maxLength: 50,
    pattern: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
    patternMessage: "Country can include only alphabets.",
  },
};

export const validateLocationField = (fieldName, value) => {
  const config = locationFieldConfig[fieldName];
  if (!config) return null;

  const v = String(value || "").trim();
  if (!v) return `${config.label} is required.`;
  if (v.length > config.maxLength)
    return `${config.label} can have up to ${config.maxLength} characters.`;
  if (!config.pattern.test(v)) return config.patternMessage;

  return null;
};

export const sanitizeLocationFieldInput = (fieldName, value) => {
  const config = locationFieldConfig[fieldName];
  if (!config) return value;

  const input = String(value || "");
  let sanitized = input;

  if (fieldName === "zipCode") {
    sanitized = sanitized.replace(/[^0-9-]/g, "");
    sanitized = sanitized.replace(/^-+/, "");
  } else {
    sanitized = sanitized.replace(/[^A-Za-z ]/g, "");
  }

  return sanitized.slice(0, config.maxLength);
};
